module.exports = __webpack_public_path__ + "static/media/29EUNOG12.8391f7fe.jpg";